import styled from 'styled-components';

export const MyCraneStyle = styled.div``;
